import { Document, Page, Text, View } from "@react-pdf/renderer";
import { stylePDF as sg } from "../styles";
import HeaderPDF from "../Header";
import FooterPDF from "../Footer";
import { Usuario } from "../../../../types/admin-usuarios/Usuario";

export default function Usuarios(data: Usuario[]) {
	return (
		<Document>
			<Page style={[sg.page]}>
				<HeaderPDF title="Usuarios" />
                    <Plantilla users={data}/>
				<FooterPDF />
			</Page>
		</Document>
	);
}

function Plantilla({ users }: { users: Array<any> }) {
	return (
		<View style={[{ marginTop: "15px" }]}>
			<View style={[sg.tBold, sg.fs11, sg.tCenter]}>
				<Text>Plantilla de usuarios</Text>
			</View>
			<View style={[{ marginTop: "8px" }]}>
				<View style={[{ marginTop: "2px" }]}>
					<View style={[sg.row, sg.bDown, sg.bTop, sg.tCenter, sg.tBold, sg.tHeader]} fixed>
						<View style={[sg.w5, sg.bEnd, sg.pCell]}>
							<Text>#</Text>
						</View>
						<View style={[sg.w35, sg.pCell]}>
							<Text>Nombre completo</Text>
						</View>
                        <View style={[sg.w35, sg.pCell, sg.bStart]}>
							<Text>Correo electrónico</Text>
						</View>
                        <View style={[sg.w25, sg.pCell, sg.bStart]}>
							<Text>Teléfono</Text>
						</View>
					</View>
                    {users.map((u: Usuario , ix: number) => (
						<UsuariosMap user={u} ix={ix} key={"rp" + ix} />
					))}
				</View>
			</View>
		</View>
	);
}

function UsuariosMap({ user, ix }: { user: Usuario, ix: number }) {
	return (
		<View style={[sg.row, sg.bDown]}>
			<View style={[sg.w5, sg.tCenter, sg.bEnd, sg.pCell]}>
                <View>
                    <Text>{ix + 1}</Text>
                </View>
			</View>
			<View style={[sg.w35, sg.bEnd, sg.pCell]}>
				<View>
					<Text>{user.fullname}</Text>
				</View>
			</View>
			<View style={[sg.w35, sg.tCenter, sg.pCell]}>
				<View>
					<Text>{user.email}</Text>
				</View>
			</View>
            <View style={[sg.w25, sg.tCenter, sg.pCell, sg.bStart]}>
				<View>
					<Text>{user.phone}</Text>
				</View>
			</View>
		</View>
	);
}
